import { commonShareLayer } from '../loaders';
import { setWindowTemplates } from '../Templates';

(() => {
    setWindowTemplates('common_share_layer', commonShareLayer);
})();
